import { ORDER_METHODS, RoomServiceLocationType } from '../../../../../../services/exports/Constants';

export default {
  title: {
    [ORDER_METHODS.DELIVERY]: 'Livrare',
    [ORDER_METHODS.ROOM_SERVICE]: {
      [RoomServiceLocationType.RoomService]: 'Serviciu la cameră',
      [RoomServiceLocationType.TableService]: 'Serviciu la masă',
    },
  },
  form: {
    doorbell_name: {
      placeholder: 'Nume interfon (opțional)',
    },
    company_name: {
      placeholder: 'Nume companie (opțional)',
    },
    customer_note: {
      placeholder: 'Instrucțiuni livrare (opțional)',
    },
    order_instructions: {
      placeholder: 'Introdu instrucțiuni pentru comandă...',
    },
  },
};
